export default __webpack_public_path__ + "static/media/Vambraces of Bone and Horn.bb3c4e88.jpg";